import { render, staticRenderFns } from "./ClientPricesList.vue?vue&type=template&id=09e7f780&"
import script from "./ClientPricesList.vue?vue&type=script&lang=js&"
export * from "./ClientPricesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports